import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NotificationPromptState {
  // Track number of app visits
  appVisitCount: number;
  
  // Track if notification prompt has been shown to avoid repeated prompts
  hasShownPrompt: boolean;
  
  // Track if user has visited social tab (to trigger social-based prompt)
  hasVisitedSocial: boolean;
  
  // Actions
  incrementVisitCount: () => void;
  markSocialVisited: () => void;
  markPromptShown: () => void;
  shouldShowPromptOnThirdVisit: () => boolean;
  shouldShowPromptOnSocialVisit: () => boolean;
  resetPromptState: () => void;
}

export const useNotificationPromptStore = create<NotificationPromptState>()(
  persist(
    (set, get) => ({
      appVisitCount: 0,
      hasShownPrompt: false,
      hasVisitedSocial: false,

      incrementVisitCount: () => {
        set((state) => ({ 
          appVisitCount: state.appVisitCount + 1 
        }));
      },

      markSocialVisited: () => {
        set({ hasVisitedSocial: true });
      },

      markPromptShown: () => {
        set({ hasShownPrompt: true });
      },

      shouldShowPromptOnThirdVisit: () => {
        const state = get();
        return state.appVisitCount >= 3 && !state.hasShownPrompt;
      },

      shouldShowPromptOnSocialVisit: () => {
        const state = get();
        return state.hasVisitedSocial && !state.hasShownPrompt;
      },

      resetPromptState: () => {
        set({
          appVisitCount: 0,
          hasShownPrompt: false,
          hasVisitedSocial: false,
        });
      },
    }),
    {
      name: 'gitfit-notification-prompt-storage',
    }
  )
);
